export default {
    UPDATE_UNREAD_CHATROOMS: 'GlobalUnreadsCount.UPDATE_UNREAD_CHATROOMS',
    MARK_CHATROOM_READ: 'GlobalUnreadsCount.MARK_CHATROOM_READ',
    MARK_CHATROOM_UNREAD: 'GlobalUnreadsCount.MARK_CHATROOM_UNREAD',
    FETCH_UNREAD_CHATROOM_IDS: 'GlobalUnreadsCount.FETCH_UNREAD_CHATROOM_IDS',
    NO_OP: 'GlobalUnreadsCount.NO_OP',
};
